import type React from "react"
import { useTranslation } from "react-i18next"

import { useData } from "@/services/data"
import { APP_COMPANY_NAME, MAIN_MENU_TOGGLE_HEIGHT } from "@/utils/constants"

import { Stack, Typography } from "@mui/material"

import type { DataGuardProps } from "./data-guard.types"

export const DataGuard: React.FC<DataGuardProps> = ({ children }) => {
  const { t } = useTranslation()
  const { dataHasData, dataIsFetched } = useData()

  return (
    <>
      {!dataIsFetched && <></>}
      {dataIsFetched && !dataHasData && (
        <Stack
          sx={{
            alignItems: "center",
            justifyContent: "center",
            bottom: 0,
            left: 0,
            pointerEvents: "none",
            position: "absolute",
            right: 0,
            top: MAIN_MENU_TOGGLE_HEIGHT,
          }}
        >
          <Typography variant="h2">{t("dataGuard.title")}</Typography>
          <Typography variant="body2">
            {t("dataGuard.description", { companyName: APP_COMPANY_NAME })}
          </Typography>
        </Stack>
      )}
      {dataIsFetched && dataHasData && <>{children}</>}
    </>
  )
}
